import { render, staticRenderFns } from "./copyCampaign.vue?vue&type=template&id=72f23acf&scoped=true"
import script from "./copyCampaign.vue?vue&type=script&lang=js"
export * from "./copyCampaign.vue?vue&type=script&lang=js"
import style0 from "./copyCampaign.vue?vue&type=style&index=0&id=72f23acf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f23acf",
  null
  
)

export default component.exports